/** 角色卡社区页的 hash 路由路径（T07b）：独立于底部导航的四条主路由。 */
export const COMMUNITY_PATH = '/community';